module.exports = __webpack_public_path__ + "img/config.c87b1a10.svg";